// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__VW9SJ","rotation":"style_rotation__7-XPz"};